import { createFileRoute } from "@tanstack/react-router";

// Catch-all splat route for all project sub-paths.
// Actual rendering is handled by ProjectContent in the keep-alive tab system.
export const Route = createFileRoute("/project/$projectId/$")({
  component: () => null,
});
